$ (function () {
    $('#saveSectionForm').validate({
        errorClass: 'invalid-text',
        rules: {
            name: {
                required: true,
                checkCharacters: true,
            },
        },
        messages: {
            name: {
                required: 'Section name is required.',
            },
        },
    });

    jQuery.validator.addMethod('checkCharacters', function (value, element) {
        return this.optional(element) || !/[\\/]/.test(value);
    }, 'Please do not use the following characters: \\ /');
});
